import React from 'react';
import DetailPage from './DetailPage';
import DetailPageHero from './DetailPageHero';

const DetailPageMicrosoft = () => {
  return (
    <DetailPage 
      title="Defining the Key Experiences of Consumer AR"
      heroSrc={'/images/microsoft/header_2.png'}
      content="At Microsoft, I led the design efforts for a cutting-edge research team exploring the future of spatial computing. While Microsoft was already well positioned in mixed reality, our vision extended far beyond, pushing the boundaries of both hardware and software. We took a holistic approach, considering every aspect of the business—most notably integrating the power of Microsoft 365's productivity suite—to shape the next generation of immersive computing."
      year="2022"
      duration="2021 - 2022"
      role="Lead Designer"
    >
      <DetailPageHero src="/images/microsoft/hero1.png" lazy={true} adaptiveAspectRatio/> 
    </DetailPage>
  );
};

export default DetailPageMicrosoft; 